import axios from "./config";

/**
 * @function
 * @name uploadPackages
 * @description upload packages
 * 
 * */
const uploadPackages = (file) => {
    const formData = new FormData();
    formData.append("file", file);
    return axios.post("/procuring_entity_packages/import", formData);
};              

const getProcuringEntityPackages = (filters = {}, page = 1, perPage = 10) => {
  let url = "/procuring_entity_packages";
  const params = new URLSearchParams();
  
  if (filters.procuring_entity_id) {
    params.append("filter[procuring_entity_id]", filters.procuring_entity_id);
  }
  
  if (filters['filter[project_id]']) {
    params.append("filter[project_id]", filters['filter[project_id]']);
  }
  
  params.append("page", page);
  params.append("per_page", perPage);
  
  params.append("all", "true");
  
  if (params.toString()) {
    url += `?${params.toString()}`;
  }
  
  return axios.get(url).then((response) => response.data);
};

const createProcuringEntityPackage = (data) => {
  return axios.post("/procuring_entity_packages", data).then((response) => response.data);
};

const updateProcuringEntityPackage = (packageId, data) => {
  return axios.put(`/procuring_entity_packages/${packageId}`, data).then((response) => response.data);
};

export default {
  uploadPackages,
  getProcuringEntityPackages,
  createProcuringEntityPackage,
  updateProcuringEntityPackage,
};
